import React from "react";
import { ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { CheckList } from "../CheckList";
import { guaranteeItems } from "../../data/content";
export function GuaranteeSection() {
  return <section className="bg-white px-4 py-16 md:py-24" data-id="element-227" data-mp="1kaazdwiits16">
      <div className="mx-auto max-w-4xl" data-id="element-228" data-mp="1fdaqzey78d6w">
        <div className="rounded-3xl border-2 border-good/30 bg-good-soft p-6 md:p-10" data-id="element-229" data-mp="1fc9dl3tpnem0">
          <div className="flex flex-col items-center text-center" data-id="element-230" data-mp="1aehbjgzcqc43">
            <div className="flex h-28 w-28 flex-col items-center justify-center rounded-full bg-good text-white ring-8 ring-white" data-id="element-231" data-mp="15e3dmrrgsijs">
              <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-232" data-mp="11dt10w962tvy" />
              <span className="font-display text-2xl font-black leading-none" data-id="element-233" data-mp="weophyyrsk2g">7-DAY</span>
              <span className="text-[10px] font-bold uppercase tracking-wide" data-id="element-234" data-mp="2vrkhaem04c0d">Guarantee</span>
            </div>
            <p className="mt-6 font-display text-sm font-extrabold uppercase tracking-wide text-good" data-id="element-235" data-mp="2qrodafdb0kkt">
              Your purchase is protected by a 7-day guarantee
            </p>
            <h2 className="mt-2 text-balance font-display text-[28px] font-black uppercase leading-tight text-ink md:text-4xl" data-id="element-236" data-mp="1l3olkvefw5ne">
              Explore the material before you decide
            </h2>
            <p className="mt-4 max-w-2xl text-lg leading-relaxed text-muted" data-id="element-237" data-mp="1c2ypdql9od95">
              I want you to have the opportunity to review the collection and decide whether it fits your educational
              needs. Your purchase is covered by a seven-day money-back guarantee, subject to the published refund
              policy.
            </p>
          </div>
          <div className="mx-auto mt-8 max-w-xl" data-id="element-238" data-mp="1q0x3cuvoe7o4">
            <p className="font-display text-sm font-extrabold uppercase tracking-wide text-ink" data-id="element-239" data-mp="1v1b1nl7h638y">After purchasing, you can:</p>
            <div className="mt-4" data-id="element-240" data-mp="2iqx1mavo8mi0">
              <CheckList items={guaranteeItems} color="#14935A" data-id="element-241" data-mp="2ipu8dwavm7yx" />
            </div>
            <p className="mt-6 text-base leading-relaxed text-muted" data-id="element-242" data-mp="2nki0e5539ki9">
              If you decide within seven days that the collection isn’t right for you, contact us within the guarantee
              period to request a refund in accordance with the published refund policy.
            </p>
          </div>
        </div>
        <div className="mt-10" data-id="element-243" data-mp="2ih4zid7jczf1">
          <CtaButton label="Get access and explore the collection" sub="One-time payment of $27 · Instant access" data-id="element-244" data-mp="2ihwhgl87mymu" />
        </div>
      </div>
    </section>;
}